import PropTypes from 'prop-types';
import React from 'react';
import { IoIosPower } from 'react-icons/io';
import {
  AspectRatio,
  Box,
  Button,
  Card,
  Container,
  Flex,
  Grid,
  IconButton,
  Image,
  Spinner,
  Text,
  ThemeProvider,
} from 'theme-ui';

import { DimLoadingIndicator, FormModal } from '../../../../components';
import SEO from '../../../../components/Seo';
import Layout from '../../../../components/layout/Layout';
import { STRINGS } from '../../../../constants';
import theme from '../../../../theme';
import SettingsMenuScreen from '../menu/SettingsMenuScreen';
import styles from './ProfileScreen.style';

const ProfileScreen = (props) => {
  const {
    profile,
    editProfileFields,
    logoutHandler,
    setIsModalVisible,
    isModalVisible,
    editProfileHandler,
    editIsLoading,
    isLoading,
    isRefreshing,
    error,
    status,
  } = props;
  const { email, slug, name, surname, bio, phone, image } = profile ?? {};

  const renderImage = () => {
    if (image) {
      return (
        <Box sx={styles.imageContainer}>
          <Box sx={styles.bgImageContainer}>
            <AspectRatio ratio={1 / 1} sx={styles.imageInnerContainer}>
              <Image ratio={1 / 1} sx={styles.image} src={image} />
            </AspectRatio>
          </Box>
        </Box>
      );
    }
    return (
      <Box sx={styles.imageContainer}>
        <Box sx={styles.bgImageContainer}>
          <AspectRatio ratio={1 / 1} sx={styles.missingPhotoContainer}>
            <Text sx={styles.missingPhotoText}>{STRINGS.workshop.missingPhoto}</Text>
          </AspectRatio>
        </Box>
      </Box>
    );
  };

  const renderRow = (label, value) => {
    if (value) {
      return (
        <Flex sx={styles.textRow}>
          <Text sx={styles.label}>{label}</Text>
          <Text sx={styles.value}>{value}</Text>
        </Flex>
      );
    }
    return (
      <Flex sx={styles.textRow}>
        <Text sx={styles.label}>{label}</Text>
        <Text sx={styles.valueDisabled}>{STRINGS.settings.noInfoText}</Text>
      </Flex>
    );
  };

  const renderProfileInfo = () => {
    return (
      <Flex sx={styles.infoContainer}>
        <Flex sx={styles.headerContainer}>
          <Text sx={styles.headerText}>{STRINGS.settings.dataText}</Text>
          <Button onClick={() => setIsModalVisible(true)} variant="mini">
            {STRINGS.settings.editText}
          </Button>
        </Flex>
        {renderRow(STRINGS.settings.nameText, name)}
        {renderRow(STRINGS.settings.surnameText, surname)}
        {renderRow(STRINGS.settings.slugText, slug)}
        {renderRow(STRINGS.settings.phoneText, phone)}
        {renderRow(STRINGS.settings.emailText, email)}
      </Flex>
    );
  };

  const renderAbout = () => {
    if (bio) {
      return (
        <Flex sx={styles.bioContainer}>
          <Flex>
            <Text sx={styles.label}>{STRINGS.settings.bioText}</Text>
          </Flex>
          <Flex sx={styles.bioTextContainer}>
            <Text sx={styles.bio}>{bio}</Text>
          </Flex>
        </Flex>
      );
    }
    return null;
  };

  const renderLogout = () => {
    return (
      <Flex sx={styles.logoutContainer}>
        <IconButton onClick={logoutHandler} sx={styles.logoutButton}>
          <Text sx={styles.logoutText}>{STRINGS.settings.logoutText}</Text>
          <IoIosPower size={22} />
        </IconButton>
      </Flex>
    );
  };
  const renderScreen = () => {
    return (
      <Card variant="settingsCard" sx={styles.card}>
        {error && (
          <Text variant="error" sx={styles.error}>
            {STRINGS.settings.error400Text}
          </Text>
        )}
        <Grid sx={styles.grid}>
          {renderImage()}
          {renderProfileInfo()}
        </Grid>
        {renderAbout()}
        {renderLogout()}
      </Card>
    );
  };

  if (status === 'authenticated' && !isLoading) {
    return (
      <ThemeProvider theme={theme}>
        <Layout>
          <SEO title={STRINGS.seo.profile} />
          <Container sx={styles.container}>
            <FormModal
              visible={isModalVisible}
              setVisible={setIsModalVisible}
              fields={editProfileFields}
              title={STRINGS.settings.editProfileText}
              action={editProfileHandler}
              actionText={STRINGS.common.edit}
              isReady
              isLoading={editIsLoading}
            />
            {isRefreshing && <DimLoadingIndicator />}
            <SettingsMenuScreen>{renderScreen()}</SettingsMenuScreen>
          </Container>
        </Layout>
      </ThemeProvider>
    );
  }
  return (
    <ThemeProvider theme={theme}>
      <Layout>
        <SEO title={STRINGS.seo.profile} />
        <Container sx={styles.container}>
          <Flex sx={styles.spinnerContainer}>
            <Spinner size={60} />
          </Flex>
        </Container>
      </Layout>
    </ThemeProvider>
  );
};

ProfileScreen.propTypes = {
  status: PropTypes.string.isRequired,
};

export default ProfileScreen;
